import { render, staticRenderFns } from "./ColorLettersAvatar.vue?vue&type=template&id=366da1ca&scoped=true&"
import script from "./ColorLettersAvatar.vue?vue&type=script&lang=js&"
export * from "./ColorLettersAvatar.vue?vue&type=script&lang=js&"
import style0 from "./ColorLettersAvatar.vue?vue&type=style&index=0&id=366da1ca&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "366da1ca",
  null
  
)

export default component.exports